import React, { useEffect } from 'react'
import PartnerCard from '../../cards/PartnerCard'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import SectionHeader from '../SectionHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getParetners } from '../../../services/actions/MainAction';
function PartnersSection() {
  const contentData = useSelector(state => state.Data.contentData);
  const lang_id = useSelector(state => state.Data.lang_id);
  const partners = useSelector(state => state.Data.partners);
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(getParetners(lang_id))
  },[lang_id])
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 3200, min: 1800 },
      items: 12
    },
    desktop: {
      breakpoint: { max: 1800, min: 1024 },
      items: 7
    },
    tablet: {
      breakpoint: { max: 1024, min: 700 },
      items: 4
    },
    mobile: {
      breakpoint: { max: 700, min: 400 },
      items: 2
    },
    mobile2: {
      breakpoint: { max: 400, min: 100 },
      items: 1
    }
  };
  return (
    <section className='mt-[50px]'>
        <div className=''>
           
            <SectionHeader title={contentData?.section_4} />
            <div  className=' gap-[20px] mt-[20px] relative'>
              <div className='absolute w-full h-[300px] top-0 left-0 flex justify-between'>
                <div className='h-[300px] w-[250px] gradient-box-left max-[600px]:hidden'> </div>
                <div className='h-[300px] w-[250px] gradient-box-right  max-[600px]:hidden'> </div>
              </div>
              <Carousel 
                 swipeable={true}
                 draggable={false}
                 
                 showDots={false}
                 responsive={responsive}
                 ssr={true} // means to render carousel on server-side.
                 infinite={true}
                 autoPlay={true}
                 autoPlaySpeed={2000}
                 keyBoardControl={false}
                 customTransition="all 2s"
                 transitionDuration={2000}
                  containerClass=""
                  dotListClass="custom-dot-list-style"
                  itemClass="carousel-item-padding-40-px"
                  
                >
            {
                partners?.map((data, i) => {
                  return (
                    <PartnerCard key={i} data={data} />
                  )
                })
              }
                </Carousel>
              
            </div>
        </div>
    </section>
  )
}

export default PartnersSection